import React, { forwardRef } from 'react';
const NonResponsiveSvg = forwardRef(({ children, width, height, svgProps = {}, }, ref) => {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", className: "game-map non-responsive-svg-map", viewBox: `0 0 ${width} ${height}`, preserveAspectRatio: "xMinYMin meet", ...svgProps, ref: ref }, children));
});
export default NonResponsiveSvg;
